import { apiRequest, getResource } from "../api/http";

// Manual reminders for unpaid payments (card renewals declined, Mobile Money
// failures), on top of the automatic ones. "transactions" section: view to
// list and preview, edit to send.
const BASE = "/api/admin/dunning";

const query = (params = {}) => {
  const entries = Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "");
  return entries.length ? `?${new URLSearchParams(entries).toString()}` : "";
};

/** `{ kind, state, q }` → `{ items, counts, cooldownHours }`. */
export const getDunning = (params) => getResource(`${BASE}${query(params)}`, { fallback: null });

/** Exact email of a reminder (nothing is sent) → `{ to, subject, html }`. */
export const previewDunning = (id) => apiRequest("post", `${BASE}/preview`, { data: { id }, select: (data) => data.email, rethrow: true });

/** Sends the reminders (100 at most per call) → `{ sent, skipped: [{ id, reason }], failed }`. */
export const sendDunning = (ids) => apiRequest("post", `${BASE}/remind`, { data: { ids }, select: (data) => data.result, rethrow: true });

export const BATCH_SIZE = 100;

export const apiError = (error) => error?.response?.data?.message || "";
